module.exports = __webpack_public_path__ + "img/catamnesis1.a71c77d0.jpg";